import actions from "../../constants/actions";

const initialState = {
    floorSlug: null,
    faqTheme: 0,
    lessonDate: null,
    isLoginVisible: false,
    isFloorVisible: false,
    isFaqVisible: false,
    isMobileClasseVisible: false,
    isMobileFaqVisible: false,
    isMobileFloorVisible: false,
    isDynamicBookingVisible: null,
    isArtisticsBookingVisible: false,
    isClaimBookingVisible: false,
    isTechnicsBookingVisible: false,
    isSpacesBookingVisible: false,
    isMobileMenuVisible: false,
    isSearchVisible: false,
};

export default function options(state = initialState, action) {
    switch (action.type) {
        case actions.CHANGE_LOGIN:
            return {
                ...state,
                isLoginVisible: action.payload.value,
            };
        case actions.CHANGE_DYNAMIC_BOOKING:
            return {
                ...state,
                isDynamicBookingVisible: action.payload.value,
            };
        case actions.CHANGE_ARTISTICS_BOOKING:
            return {
                ...state,
                isArtisticsBookingVisible: action.payload.value,
            };
        case actions.CHANGE_CLAIM_BOOKING:
            return {
                ...state,
                isClaimBookingVisible: action.payload.value,
            };
        case actions.CHANGE_TECHNICS_BOOKING:
            return {
                ...state,
                isTechnicsBookingVisible: action.payload.value,
            };
        case actions.CHANGE_SPACES_BOOKING:
            return {
                ...state,
                isSpacesBookingVisible: action.payload.value,
            };
        case actions.CHANGE_SEARCH:
            return {
                ...state,
                isSearchVisible: action.payload.value,
            };
        case actions.CHANGE_MOBILE_MENU:
            return {
                ...state,
                isMobileMenuVisible: action.payload.value,
            };
        case actions.CHANGE_FLOOR:
            return {
                ...state,
                isFloorVisible: action.payload.value,
                floorSlug: action.payload.slug,
            };
        case actions.CHANGE_FAQ:
            return {
                ...state,
                isFaqVisible: action.payload.value,
                faqTheme: action.payload.theme,
            };
        case actions.CHANGE_MOBILE_FLOOR:
            return {
                ...state,
                isMobileFloorVisible: action.payload.value,
                floorSlug: action.payload.slug,
            };
        case actions.CHANGE_MOBILE_FAQ:
            return {
                ...state,
                isMobileFaqVisible: action.payload.value,
                faqTheme: action.payload.theme,
            };
        case actions.CHANGE_MOBILE_CLASSE:
            return {
                ...state,
                isMobileClasseVisible: action.payload.value,
                lessonDate: action.payload.lesson,
            };
        case actions.LOGIN_SUCCESS:
            return {
                isLoginVisible: false,
            };
        default:
            return state;
    }
}
